import { Directive, HostListener } from "@angular/core";

@Directive({
  selector: "[appBlockCopyPaste]"
})
export class BlockCopyPasteDirective {
  constructor() { }

  @HostListener("paste", ["$event"]) blockPaste(e: KeyboardEvent): void {
    e.preventDefault();
  }

  @HostListener("copy", ["$event"]) blockCopy(e: KeyboardEvent): void {
    e.preventDefault();
  }

  @HostListener("cut", ["$event"]) blockCut(e: KeyboardEvent): void {
    e.preventDefault();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/permission/directive/block-copy-paste.directive.ts